import sentry from './sentry';

export default {
  sentry,
};
